import { Grid } from '@material-ui/core'
import './Structure.scoped.scss'

export const Structure = ({ data, extra, block, identifier, editKey, editing }) => {
  if (editing && editKey) {
    return null
  }

  return (
    <Grid item container direction="row" className={`${editing ? 'margin-bottom double' : ''}`}>
      <Grid item xs={5} className="dark-grey title">
        <span>{identifier}</span>
      </Grid>

      <Grid item xs={7} className="data">
        <div className="flex">
          {block ? (
            data
          ) : (
            <div>
              {data && <b>{data}</b>}
              {!data && <i>Not available</i>}
              {data && <span>{extra || ''}</span>}
            </div>
          )}
        </div>
      </Grid>
    </Grid>
  )
}

export default Structure
